import Vue from 'vue'
import Vuex from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
import common from './modules/common'
import user from './modules/user'
import configure from './modules/configure'
import song from './modules/song'
import brand from './modules/brand'
import category from './modules/category'

Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    configure,
    song,
    common,
    user,
    brand,
    category,
  },
  mutations: {
    // 重置vuex本地储存状态
    resetStore (state) {
      Object.keys(state).forEach((key) => {
        state[key] = cloneDeep(window.SITE_CONFIG['storeState'][key])
      })
    }
  },
  strict: process.env.NODE_ENV !== 'production'
})

export default store
